import React, { useState } from "react";
import { axInst } from "../../../Components/Login/Service";
import {
  flexRender,
  getCoreRowModel,
  useReactTable,
  getFilteredRowModel,
  getPaginationRowModel,
  getSortedRowModel,
} from "@tanstack/react-table";
import { useQuery } from "@tanstack/react-query";
import { Loader } from "rsuite";
import { useSelector } from "react-redux";
import WaterMark from "../../../Components/WaterMark/WaterMark";

const fetchTableData = async (body) => {
  try {
    const res = await axInst.post(
      "/complaints/escalation_complaint_details",
      body,
    );
    const data = res.data;

    return data;
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const EsclatedComplaintDetails = ({ closeModal }) => {
  const { data, submitted } = useSelector((state) => state.filtersComplaint);
  const [sorting, setSorting] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [pageIndex, setPageIndex] = useState(0);

  const {
    data: tabledata,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["Tabledetailed", submitted],
    queryFn: () => fetchTableData(data),
    initialData: [],
    cacheTime: 0,
    staleTime: 0,
  });

  // Define table columns
  const columns = [
    {
      header: "Complt #",
      accessorFn: (row) => row.SR_NUM,
    },
    {
      header: "Region",
      accessorFn: (row) => row.REGION,
    },
    {
      header: "Date",
      accessorFn: (row) => row.OPEN_DATE,
    },
    {
      header: "Origin",
      accessorFn: (row) => row.X_ATTRIB_04,
    },
    {
      header: "Primary Clt Area",
      accessorFn: (row) => row.AREA,
    },
    {
      header: "Sub Area",
      accessorFn: (row) => row.SUB_AREA,
    },
    {
      header: "Open For Days",
      accessorFn: (row) => row.OPEN_FOR_DAYS,
    },
    {
      header: "Created Date",
      accessorFn: (row) => row.CREATED_DATE,
    },
    {
      header: "Mode",
      accessorFn: (row) => row.COMM_METHOD_CD,
    },

    {
      header: "Sub Status",
      accessorFn: (row) => row.SUB_STATUS,
    },
    {
      header: "Chassis NO",
      accessorFn: (row) => row.CHASSIS_NUMBER,
    },
    {
      header: "Vechile Registration NO",
      accessorFn: (row) => row.VEHICLE_REGISTRATION_NUMBER,
    },
  ];

  // Initialize table
  const table = useReactTable({
    data: tabledata,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    state: {
      sorting,
      globalFilter,
    },
    initialState: {
      pagination: {
        pageIndex,
        pageSize: 8,
      },
    },
    onSortingChange: setSorting,
    onGlobalFilterChange: setGlobalFilter, // Updated to handle global filter
  });

  const goToPage = (index) => {
    setPageIndex(index);
    table.setPageIndex(index);
  };

  return (
    <div className="modal-overlay">
      <div className="modal relative  w-full">
        <div className="flex justify-between items-center">
          <div className="font-bold">
            <h2>Open Esclated Complaints</h2>
          </div>
          <div className="flex justify-end">
            <input
              type="text"
              value={globalFilter}
              onChange={(e) => setGlobalFilter(e.target.value)}
              placeholder="Search..."
              className="p-1 mb-2 border rounded text-[12px]"
            />
          </div>
        </div>
        <button
          onClick={closeModal}
          className="close-button rounded-full absolute -right-[13px] -top-[18px] w-8 h-8 flex justify-center border border-red-600 items-center"
        >
          &times;
        </button>
        <div className="flex-auto mt-2">
          <div className="self-center overflow-auto h-[320px] ">
            {isError && (
              <div className="grid items-center justify-center w-full h-full">
                <p>Error Occurred</p>
              </div>
            )}
            {isFetching && (
              <div className="grid items-center justify-center w-full h-full">
                <Loader size="lg" />
              </div>
            )}
            <WaterMark />
            {!isFetching && !isError && (
              <>
                {tabledata && tabledata.length > 0 ? (
                  <>
                    {/* <div className="flex justify-end">
                      <input
                        type="text"
                        value={globalFilter}
                        onChange={(e) => setGlobalFilter(e.target.value)}
                        placeholder="Search..."
                        className="p-1 mb-2 border rounded text-[12px]"
                      />
                    </div> */}
                    <table className="w-full text-left">
                      <thead className="sticky text-white top-0  bg-[#2A5775]">
                        {table.getHeaderGroups().map((headerGroup) => (
                          <tr key={headerGroup.id}>
                            {headerGroup.headers.map((header) => (
                              <th
                                key={header.id}
                                className="py-4 px-0.5 text-xs font-normal lg:px-1 lg:font-medium lg:text-sm border-1 whitespace-nowrap"
                              >
                                {header.isPlaceholder
                                  ? null
                                  : flexRender(
                                      header.column.columnDef.header,
                                      header.getContext(),
                                    )}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody>
                        {table.getRowModel().rows.map((row) => (
                          <tr
                            key={row.id}
                            className="even:bg-gray-200 odd:bg-white"
                          >
                            {row.getVisibleCells().map((cell, index) => (
                              <td
                                key={cell.id}
                                className={`p-[2px] whitespace-nowrap text-xs lg:text-sm border-1 h-8 ${
                                  index === 6 ? "text-center" : ""
                                }`}
                              >
                                {flexRender(
                                  cell.column.columnDef.cell,
                                  cell.getContext(),
                                )}
                              </td>
                            ))}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </>
                ) : (
                  <div className="grid items-center justify-center w-full h-full">
                    <p>Data is not available.</p>
                  </div>
                )}
              </>
            )}
          </div>

          <div className="flex py-2 justify-evenly">
            <button
              onClick={() => {
                const prevIndex = pageIndex - 1;
                if (prevIndex >= 0) {
                  setPageIndex(prevIndex);
                  table.setPageIndex(prevIndex);
                }
              }}
              disabled={!table.getCanPreviousPage()}
            >
              {"⬅️"} Previous Page
            </button>

            <div className="flex self-center gap-2">
              <span>Go to page :</span>
              <input
                type="number"
                max={table.getPageCount()}
                min={1}
                value={pageIndex + 1}
                onChange={(e) => {
                  const page = parseInt(e.target.value, 10);
                  if (!isNaN(page)) {
                    goToPage(page - 1);
                  }
                }}
                className="w-12 text-center border rounded"
              />
              <span>of {table.getPageCount()}</span>
            </div>

            <button
              onClick={() => {
                const nextIndex = pageIndex + 1;
                if (table.getCanNextPage()) {
                  setPageIndex(nextIndex);
                  table.setPageIndex(nextIndex);
                }
              }}
              disabled={!table.getCanNextPage()}
            >
              Next page {"➡️"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
